import { currentSaleFilter } from "actions/lib";

import { getLivestockSaleId } from "lib/navigation";

export const crashReporterMiddleware = store => next => action => {
  // Middleware to log exceptions when processing actions (Ie provides visiblity of JS_ERROR errors)
  try {
    return next(action);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Caught an exception!", err, store.getState(), action);
    throw err;
  }
};

export const wrongSaleDiscarderMiddleware = () => next => action => {
  if (action.meta?.offline) {
    // Offline actions need to get filtered in the effect, and
    // some actions just need to be acknowledged.
    return next(action);
  }

  if (!currentSaleFilter(action)) {
    // eslint-disable-next-line no-console
    console.warn(
      `Discarding network response for non-offline middlware ${
        action.type
      } from sale ${
        action.meta.livestockSaleId
      } while in ${getLivestockSaleId()}`,
    );
    return;
  }

  return next(action);
};
